import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	reactionContainer: {
		position: "absolute",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		width: "fit-content",
		padding: "1px 4px",
		borderRadius: 12
	},
	reactionsCount: {
		width: 19,
		height: 24,
		textAlign: "center"
	},
	drawerPaper: {
		width: 200,
		position: "absolute"
	},
	clientIdentification: {

	},
	avatarContainer: {
		alignSelf: "center"
	},
	avatar: {
		width: 44,
		height: 44,
		fontSize: "32px"
	},
	tabs: {
		width: "100%",
		position: "relative",
		"&::before": {
			content: "close-quote",
			position: "absolute",
			width: "100%",
			height: "1px",
			bottom: 0,
			left: 0,
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		}
	},
	tab: {
		color: `${colors.gray[700]} !important`,
		opacity: 1,
		fontSize: 14
	},
	tabIndicator: {
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor())
	},
	tabRoot: {
		minWidth: 65
	}
})

export default useStyles
